"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CityPark = void 0;
const Tags_1 = require("./../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("./../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const CardRequirements_1 = require("../CardRequirements");
class CityPark extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.CITY_PARK,
            tags: [Tags_1.Tags.PLANT],
            cost: 7,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.cities(3)),
            metadata: {
                cardNumber: 'X71',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.plants(2);
                }),
                description: 'Requires that you have three cities in play. Gain 2 plants.',
                victoryPoints: 2,
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.PLANTS, 2);
        return undefined;
    }
    getVictoryPoints() {
        return 2;
    }
}
exports.CityPark = CityPark;
//# sourceMappingURL=CityPark.js.map